import React, {useEffect, useState} from 'react'
import { Dropdown, Grid, Input, Button, Icon } from 'semantic-ui-react'
import {useForm, Controller} from "react-hook-form"
import WebsitesData from "../Sections/WebsitesData"
import './style.css'

const WEBSITE_SQL_WEBHOOK = "https://api.axc.ae/webhook/b1acf1f9-ffab-4131-9379-7bfb7cea29fe";

const sqlString = (value) => {
    if (value === undefined || value === null || value === '') {
        return 'NULL';
    }

    return `'${value.toString().replace(/'/g, "''")}'`;
}

const sqlNumber = (value) => {
    if (value === undefined || value === null || value === '') {
        return 'NULL';
    }

    return Number(value);
}

const sqlJsonb = (value) => {
    const jsonValue = JSON.stringify(Array.isArray(value) ? value : []);

    return `'${jsonValue.replace(/'/g, "''")}'::jsonb`;
}

const generateIntegrationId = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);

    return Array.from(bytes, byte => chars[byte % chars.length]).join('');
}

const buildWebsiteInsertSql = (fields) => {
    const duplicatesFilter = fields.duplicates_filter || fields.name;

    return `
INSERT INTO websites (
    integration_id,
    name,
    duplicates_filter,
    source_details,
    ad_project,
    marker,
    responsible,
    tags
)
VALUES (
    ${sqlString(fields.integration_id)},
    ${sqlString(fields.name)},
    ${sqlString(duplicatesFilter)},
    ${sqlString(fields.source_details)},
    ${sqlNumber(fields.Ad_Project)},
    ${sqlString(fields.marker)},
    ${sqlNumber(fields.responsible)},
    ${sqlJsonb(fields.tags)}
)
RETURNING id;`.trim();
}

const Websites = () => {
    const {
        control,
        handleSubmit,
        reset
    } = useForm()

    const [projects, setProject] = useState([])
    const [responsible, setResponsible] = useState([])
    const [tags, setTags] = useState([])
    const [responseMessage, setResponseMessage] = useState('');
    const [refreshKey, setRefreshKey] = useState(0);

    async function adProject(){
        const response = await fetch('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1568907438');
        const data = await response.json();
        setProject(data.result?.[0]?.LIST || [])
    }
    
    async function adResponsible(){
        const response = await fetch('https://crm.axcap.ae/local/webhooks/getUserIdName.php?api_key=UPmcMSpk86SLPprv');
        const data = await response.json();
        setResponsible(data)
    }

    async function adTags(){
        let start = 0;
        let allTags = [];

        while (start !== null) {
            const response = await fetch(`https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/lists.element.get?IBLOCK_TYPE_ID=lists&IBLOCK_ID=189&ELEMENT_ORDER%5BID%5D=ASC&start=${start}`);
            const data = await response.json();

            allTags = allTags.concat(data.result || []);
            start = data.next ?? null;
        }

        setTags(allTags)
    }

    useEffect(() => {
        adProject();
        adResponsible();
        adTags();
    }, [])

    const transformProject = projects.map(project => ({
        key: project.ID,
        text: project.VALUE,
        value: project.ID
    }))
    
    const transformResponsible = responsible.map(responsibleItem => ({
        key: responsibleItem.ID,
        text: responsibleItem.NAME,
        value: responsibleItem.ID
    }))
    transformResponsible.push({key: 1, text: 'AX CAPITAL', value: '1'})

    const transformTags = tags.map(tag => ({
        key: tag.ID,
        text: tag.NAME,
        value: tag.ID
    }))

    const onSubmit = async (fields) => {
        const preparedFields = {
            ...fields,
            integration_id: generateIntegrationId(),
            duplicates_filter: fields.duplicates_filter || fields.name
        }

        try {
            const sql = buildWebsiteInsertSql(preparedFields);
            const response = await fetch(WEBSITE_SQL_WEBHOOK, {
                method: 'POST',
                mode: 'cors', 
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify({fields: preparedFields, sql, "source": "website"}) 
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const data = await response.json();
            setResponseMessage({
                ...data,
                integration_id: preparedFields.integration_id
            }); 

            reset();
            setRefreshKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error('Error:', error);
            setResponseMessage('An error occurred');
        }
    }

    return(
        <>
            <h1 className='title'>-- Landings --</h1>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container columns='equal' className='grid-form'>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Landing URL / Name</span>
                                <Controller
                                    name='name'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input type='text' placeholder='https://...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>Responsible</span>
                                <Controller
                                    name='responsible'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='select responsible'
                                            fluid
                                            search
                                            selection
                                            options={transformResponsible}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )} 
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Duplicates Filter</span>
                                <Controller
                                    name='duplicates_filter'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input type='text' placeholder='Leave empty to use URL' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>Project</span>
                                <Controller
                                    name='Ad_Project'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Project'
                                            fluid
                                            search
                                            selection
                                            options={transformProject}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )} 
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Source Details</span>
                                <Controller
                                    name='source_details'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>Marker</span>
                                <Controller
                                    name='marker'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Tags</span>
                                <Controller
                                    name='tags'
                                    defaultValue={[]}
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Tags'
                                            fluid
                                            multiple
                                            search
                                            selection
                                            options={transformTags}
                                            value={value}
                                            onOpen={adTags}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                        </Grid.Column>
                    </Grid.Row>
                    <Button animated className='fb-button'>
                        <Button.Content visible>Create Integration</Button.Content>
                        <Button.Content hidden>
                            <Icon name='arrow right' />
                        </Button.Content>
                    </Button>
                </Grid>
            </form>
            {responseMessage && (
                <div className='reponse-message'>
                    <p>Response: {responseMessage.message} | ID: {responseMessage.id} | Integration ID: {responseMessage.integration_id}</p>
                </div>
            )}
            <WebsitesData refreshKey={refreshKey}/>
        </>
    )
}

export default Websites;
